"use client";

import { useCookieConsent } from "@/contexts/CookieConsentContext";
import { GoogleAnalytics } from "@next/third-parties/google";

export default function Analytics() {
  const { acceptedCookies } = useCookieConsent();

  return acceptedCookies && <GoogleAnalytics gaId="G-T3XHPZL5Z0" />;
}
